// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/integration/external_ticketing/jira/v1/jira.proto" (package "c1.api.external_ticketing.jira.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// For the get requests, I'm basing the parameters on what we actually use on the support dashboard

/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.Installations
 */
export interface Installations {
    /**
     * @generated from protobuf field: string installation_id = 1
     */
    installationId: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetInstallationsRequest
 */
export interface GetInstallationsRequest {
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetInstallationsResponse
 */
export interface GetInstallationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Installations installations = 1
     */
    installations: Installations[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetProjectsRequest
 */
export interface GetProjectsRequest {
    /**
     * @generated from protobuf field: string installation_id = 1
     */
    installationId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetProjectsResponse
 */
export interface GetProjectsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Project projects = 1
     */
    projects: Project[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetCustomAppFieldsRequest
 */
export interface GetCustomAppFieldsRequest {
    /**
     * @generated from protobuf field: string installation_id = 1
     */
    installationId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetCustomAppFieldsResponse
 */
export interface GetCustomAppFieldsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Field fields = 1
     */
    fields: Field[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetFieldsRequest
 */
export interface GetFieldsRequest {
    /**
     * @generated from protobuf field: string installation_id = 1
     */
    installationId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetFieldsResponse
 */
export interface GetFieldsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Field fields = 1
     */
    fields: Field[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetTextFieldsRequest
 */
export interface GetTextFieldsRequest {
    /**
     * @generated from protobuf field: string installation_id = 1
     */
    installationId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetTextFieldsResponse
 */
export interface GetTextFieldsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Field fields = 1
     */
    fields: Field[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetStatusesRequest
 */
export interface GetStatusesRequest {
    /**
     * @generated from protobuf field: string installation_id = 1
     */
    installationId: string;
    /**
     * @generated from protobuf field: string project_id = 2
     */
    projectId: string;
    /**
     * @generated from protobuf field: string category = 3
     */
    category: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetStatusesResponse
 */
export interface GetStatusesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.JiraStatus statuses = 1
     */
    statuses: JiraStatus[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetResolutionsRequest
 */
export interface GetResolutionsRequest {
    /**
     * @generated from protobuf field: string installation_id = 1
     */
    installationId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetResolutionsResponse
 */
export interface GetResolutionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.ResolutionState resolutions = 1
     */
    resolutions: ResolutionState[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetRequestTypesRequest
 */
export interface GetRequestTypesRequest {
    /**
     * @generated from protobuf field: string installation_id = 1
     */
    installationId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetRequestTypesResponse
 */
export interface GetRequestTypesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.ServiceDeskRequestType request_types = 1
     */
    requestTypes: ServiceDeskRequestType[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetAllOptionsFromJiraApiRequest
 */
export interface GetAllOptionsFromJiraApiRequest {
    /**
     * @generated from protobuf field: string installation_id = 1
     */
    installationId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.GetAllOptionsFromJiraApiResponse
 */
export interface GetAllOptionsFromJiraApiResponse {
    /**
     * @generated from protobuf field: string installation_id = 1
     */
    installationId: string;
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Project projects = 2
     */
    projects: Project[];
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Field fields = 3
     */
    fields: Field[];
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Field text_fields = 4
     */
    textFields: Field[];
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Field custom_app_fields = 5
     */
    customAppFields: Field[];
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.ResolutionState resolutions = 6
     */
    resolutions: ResolutionState[];
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.ServiceDeskRequestType request_types = 7
     */
    requestTypes: ServiceDeskRequestType[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.BindJiraRequest
 */
export interface BindJiraRequest {
    /**
     * @generated from protobuf field: string base_url = 1
     */
    baseUrl: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string integration_ref_id = 3
     */
    integrationRefId: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.BindJiraResponse
 */
export interface BindJiraResponse {
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.JiraConfig
 */
export interface JiraConfig {
    /**
     * @generated from protobuf field: string project_id = 1
     */
    projectId: string;
    /**
     * @generated from protobuf field: string user_field_id = 2
     */
    userFieldId: string;
    /**
     * @generated from protobuf field: bool c1_label_filter = 3
     */
    c1LabelFilter: boolean;
    /**
     * @generated from protobuf field: string app_field_id = 4
     */
    appFieldId: string;
    /**
     * @generated from protobuf field: string resource_field_id = 5
     */
    resourceFieldId: string;
    /**
     * Labels don't have an id, just its name
     *
     * @generated from protobuf field: string requires_it_admin_label = 6
     */
    requiresItAdminLabel: string;
    /**
     * The resolution status id for what is considered resolved
     *
     * @generated from protobuf field: string status_id = 7
     */
    statusId: string;
    /**
     * The resolution state id for service desk's finer grained resolution states (Done, Wont Do, etc.)
     *
     * @generated from protobuf field: string cancelled_resolution_id = 8
     */
    cancelledResolutionId: string;
    /**
     * @generated from protobuf field: string denied_resolution_id = 9
     */
    deniedResolutionId: string;
    /**
     * @generated from protobuf field: string granted_resolution_id = 10
     */
    grantedResolutionId: string;
    /**
     * @generated from protobuf field: string manual_provision_errored_resolution_id = 11
     */
    manualProvisionErroredResolutionId: string;
    /**
     * @generated from protobuf field: string request_type_id = 12
     */
    requestTypeId: string;
    /**
     * @generated from protobuf field: bool comments_internal = 13
     */
    commentsInternal: boolean;
    /**
     * @generated from protobuf field: bool auto_submit = 14
     */
    autoSubmit: boolean;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.Project
 */
export interface Project {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.Field
 */
export interface Field {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.ResolutionState
 */
export interface ResolutionState {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: bool is_default = 4
     */
    isDefault: boolean;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.JiraStatus
 */
export interface JiraStatus {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: string status_category = 4
     */
    statusCategory: string;
    /**
     * @generated from protobuf field: c1.api.external_ticketing.jira.v1.Scope scope = 5
     */
    scope?: Scope;
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.Usage usages = 6
     */
    usages: Usage[];
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.jira.v1.WorkflowUsage workflow_usages = 7
     */
    workflowUsages: WorkflowUsage[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.Scope
 */
export interface Scope {
    /**
     * @generated from protobuf field: c1.api.external_ticketing.jira.v1.ProjectId project = 1
     */
    project?: ProjectId;
    /**
     * @generated from protobuf field: string type = 2
     */
    type: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.Usage
 */
export interface Usage {
    /**
     * @generated from protobuf field: repeated string issue_types = 1
     */
    issueTypes: string[];
    /**
     * @generated from protobuf field: c1.api.external_ticketing.jira.v1.ProjectId project = 2
     */
    project?: ProjectId;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.ProjectId
 */
export interface ProjectId {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.WorkflowUsage
 */
export interface WorkflowUsage {
    /**
     * @generated from protobuf field: string workflow_id = 1
     */
    workflowId: string;
    /**
     * @generated from protobuf field: string workflow_name = 2
     */
    workflowName: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.ServiceDeskRequestType
 */
export interface ServiceDeskRequestType {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: string help_text = 4
     */
    helpText: string;
    /**
     * @generated from protobuf field: string issue_type_id = 5
     */
    issueTypeId: string;
    /**
     * @generated from protobuf field: string service_desk_id = 6
     */
    serviceDeskId: string;
    /**
     * @generated from protobuf field: string portal_id = 7
     */
    portalId: string;
    /**
     * @generated from protobuf field: repeated string group_ids = 8
     */
    groupIds: string[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.jira.v1.ServiceDeskIssueRequest
 */
export interface ServiceDeskIssueRequest {
    /**
     * @generated from protobuf field: string issue_id = 1
     */
    issueId: string;
    /**
     * @generated from protobuf field: string issue_key = 2
     */
    issueKey: string;
    /**
     * @generated from protobuf field: string request_type_id = 3
     */
    requestTypeId: string;
    /**
     * @generated from protobuf field: string service_desk_id = 4
     */
    serviceDeskId: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Installations$Type extends MessageType<Installations> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.Installations", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Installations>): Installations {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.installationId = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<Installations>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Installations): Installations {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string installation_id */ 1:
                    message.installationId = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Installations, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string installation_id = 1; */
        if (message.installationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.installationId);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.Installations
 */
export const Installations = new Installations$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInstallationsRequest$Type extends MessageType<GetInstallationsRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetInstallationsRequest", []);
    }
    create(value?: PartialMessage<GetInstallationsRequest>): GetInstallationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInstallationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInstallationsRequest): GetInstallationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInstallationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetInstallationsRequest
 */
export const GetInstallationsRequest = new GetInstallationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInstallationsResponse$Type extends MessageType<GetInstallationsResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetInstallationsResponse", [
            { no: 1, name: "installations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Installations }
        ]);
    }
    create(value?: PartialMessage<GetInstallationsResponse>): GetInstallationsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.installations = [];
        if (value !== undefined)
            reflectionMergePartial<GetInstallationsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInstallationsResponse): GetInstallationsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.external_ticketing.jira.v1.Installations installations */ 1:
                    message.installations.push(Installations.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInstallationsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.external_ticketing.jira.v1.Installations installations = 1; */
        for (let i = 0; i < message.installations.length; i++)
            Installations.internalBinaryWrite(message.installations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetInstallationsResponse
 */
export const GetInstallationsResponse = new GetInstallationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetProjectsRequest$Type extends MessageType<GetProjectsRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetProjectsRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetProjectsRequest>): GetProjectsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.installationId = "";
        if (value !== undefined)
            reflectionMergePartial<GetProjectsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetProjectsRequest): GetProjectsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string installation_id */ 1:
                    message.installationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetProjectsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string installation_id = 1; */
        if (message.installationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.installationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetProjectsRequest
 */
export const GetProjectsRequest = new GetProjectsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetProjectsResponse$Type extends MessageType<GetProjectsResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetProjectsResponse", [
            { no: 1, name: "projects", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Project }
        ]);
    }
    create(value?: PartialMessage<GetProjectsResponse>): GetProjectsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.projects = [];
        if (value !== undefined)
            reflectionMergePartial<GetProjectsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetProjectsResponse): GetProjectsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.external_ticketing.jira.v1.Project projects */ 1:
                    message.projects.push(Project.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetProjectsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.external_ticketing.jira.v1.Project projects = 1; */
        for (let i = 0; i < message.projects.length; i++)
            Project.internalBinaryWrite(message.projects[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetProjectsResponse
 */
export const GetProjectsResponse = new GetProjectsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomAppFieldsRequest$Type extends MessageType<GetCustomAppFieldsRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetCustomAppFieldsRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetCustomAppFieldsRequest>): GetCustomAppFieldsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.installationId = "";
        if (value !== undefined)
            reflectionMergePartial<GetCustomAppFieldsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomAppFieldsRequest): GetCustomAppFieldsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string installation_id */ 1:
                    message.installationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomAppFieldsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string installation_id = 1; */
        if (message.installationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.installationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetCustomAppFieldsRequest
 */
export const GetCustomAppFieldsRequest = new GetCustomAppFieldsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomAppFieldsResponse$Type extends MessageType<GetCustomAppFieldsResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetCustomAppFieldsResponse", [
            { no: 1, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field }
        ]);
    }
    create(value?: PartialMessage<GetCustomAppFieldsResponse>): GetCustomAppFieldsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fields = [];
        if (value !== undefined)
            reflectionMergePartial<GetCustomAppFieldsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomAppFieldsResponse): GetCustomAppFieldsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.external_ticketing.jira.v1.Field fields */ 1:
                    message.fields.push(Field.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomAppFieldsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.external_ticketing.jira.v1.Field fields = 1; */
        for (let i = 0; i < message.fields.length; i++)
            Field.internalBinaryWrite(message.fields[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetCustomAppFieldsResponse
 */
export const GetCustomAppFieldsResponse = new GetCustomAppFieldsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFieldsRequest$Type extends MessageType<GetFieldsRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetFieldsRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetFieldsRequest>): GetFieldsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.installationId = "";
        if (value !== undefined)
            reflectionMergePartial<GetFieldsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetFieldsRequest): GetFieldsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string installation_id */ 1:
                    message.installationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetFieldsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string installation_id = 1; */
        if (message.installationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.installationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetFieldsRequest
 */
export const GetFieldsRequest = new GetFieldsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFieldsResponse$Type extends MessageType<GetFieldsResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetFieldsResponse", [
            { no: 1, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field }
        ]);
    }
    create(value?: PartialMessage<GetFieldsResponse>): GetFieldsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fields = [];
        if (value !== undefined)
            reflectionMergePartial<GetFieldsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetFieldsResponse): GetFieldsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.external_ticketing.jira.v1.Field fields */ 1:
                    message.fields.push(Field.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetFieldsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.external_ticketing.jira.v1.Field fields = 1; */
        for (let i = 0; i < message.fields.length; i++)
            Field.internalBinaryWrite(message.fields[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetFieldsResponse
 */
export const GetFieldsResponse = new GetFieldsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTextFieldsRequest$Type extends MessageType<GetTextFieldsRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetTextFieldsRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetTextFieldsRequest>): GetTextFieldsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.installationId = "";
        if (value !== undefined)
            reflectionMergePartial<GetTextFieldsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTextFieldsRequest): GetTextFieldsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string installation_id */ 1:
                    message.installationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTextFieldsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string installation_id = 1; */
        if (message.installationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.installationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetTextFieldsRequest
 */
export const GetTextFieldsRequest = new GetTextFieldsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTextFieldsResponse$Type extends MessageType<GetTextFieldsResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetTextFieldsResponse", [
            { no: 1, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field }
        ]);
    }
    create(value?: PartialMessage<GetTextFieldsResponse>): GetTextFieldsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fields = [];
        if (value !== undefined)
            reflectionMergePartial<GetTextFieldsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTextFieldsResponse): GetTextFieldsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.external_ticketing.jira.v1.Field fields */ 1:
                    message.fields.push(Field.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTextFieldsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.external_ticketing.jira.v1.Field fields = 1; */
        for (let i = 0; i < message.fields.length; i++)
            Field.internalBinaryWrite(message.fields[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetTextFieldsResponse
 */
export const GetTextFieldsResponse = new GetTextFieldsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatusesRequest$Type extends MessageType<GetStatusesRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetStatusesRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "project_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "category", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetStatusesRequest>): GetStatusesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.installationId = "";
        message.projectId = "";
        message.category = "";
        if (value !== undefined)
            reflectionMergePartial<GetStatusesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStatusesRequest): GetStatusesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string installation_id */ 1:
                    message.installationId = reader.string();
                    break;
                case /* string project_id */ 2:
                    message.projectId = reader.string();
                    break;
                case /* string category */ 3:
                    message.category = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStatusesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string installation_id = 1; */
        if (message.installationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.installationId);
        /* string project_id = 2; */
        if (message.projectId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.projectId);
        /* string category = 3; */
        if (message.category !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.category);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetStatusesRequest
 */
export const GetStatusesRequest = new GetStatusesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatusesResponse$Type extends MessageType<GetStatusesResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetStatusesResponse", [
            { no: 1, name: "statuses", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JiraStatus }
        ]);
    }
    create(value?: PartialMessage<GetStatusesResponse>): GetStatusesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.statuses = [];
        if (value !== undefined)
            reflectionMergePartial<GetStatusesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStatusesResponse): GetStatusesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.external_ticketing.jira.v1.JiraStatus statuses */ 1:
                    message.statuses.push(JiraStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStatusesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.external_ticketing.jira.v1.JiraStatus statuses = 1; */
        for (let i = 0; i < message.statuses.length; i++)
            JiraStatus.internalBinaryWrite(message.statuses[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetStatusesResponse
 */
export const GetStatusesResponse = new GetStatusesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetResolutionsRequest$Type extends MessageType<GetResolutionsRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetResolutionsRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetResolutionsRequest>): GetResolutionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.installationId = "";
        if (value !== undefined)
            reflectionMergePartial<GetResolutionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetResolutionsRequest): GetResolutionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string installation_id */ 1:
                    message.installationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetResolutionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string installation_id = 1; */
        if (message.installationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.installationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetResolutionsRequest
 */
export const GetResolutionsRequest = new GetResolutionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetResolutionsResponse$Type extends MessageType<GetResolutionsResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetResolutionsResponse", [
            { no: 1, name: "resolutions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResolutionState }
        ]);
    }
    create(value?: PartialMessage<GetResolutionsResponse>): GetResolutionsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resolutions = [];
        if (value !== undefined)
            reflectionMergePartial<GetResolutionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetResolutionsResponse): GetResolutionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.external_ticketing.jira.v1.ResolutionState resolutions */ 1:
                    message.resolutions.push(ResolutionState.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetResolutionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.external_ticketing.jira.v1.ResolutionState resolutions = 1; */
        for (let i = 0; i < message.resolutions.length; i++)
            ResolutionState.internalBinaryWrite(message.resolutions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetResolutionsResponse
 */
export const GetResolutionsResponse = new GetResolutionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRequestTypesRequest$Type extends MessageType<GetRequestTypesRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetRequestTypesRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetRequestTypesRequest>): GetRequestTypesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.installationId = "";
        if (value !== undefined)
            reflectionMergePartial<GetRequestTypesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetRequestTypesRequest): GetRequestTypesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string installation_id */ 1:
                    message.installationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetRequestTypesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string installation_id = 1; */
        if (message.installationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.installationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetRequestTypesRequest
 */
export const GetRequestTypesRequest = new GetRequestTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRequestTypesResponse$Type extends MessageType<GetRequestTypesResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetRequestTypesResponse", [
            { no: 1, name: "request_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServiceDeskRequestType }
        ]);
    }
    create(value?: PartialMessage<GetRequestTypesResponse>): GetRequestTypesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestTypes = [];
        if (value !== undefined)
            reflectionMergePartial<GetRequestTypesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetRequestTypesResponse): GetRequestTypesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.external_ticketing.jira.v1.ServiceDeskRequestType request_types */ 1:
                    message.requestTypes.push(ServiceDeskRequestType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetRequestTypesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.external_ticketing.jira.v1.ServiceDeskRequestType request_types = 1; */
        for (let i = 0; i < message.requestTypes.length; i++)
            ServiceDeskRequestType.internalBinaryWrite(message.requestTypes[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetRequestTypesResponse
 */
export const GetRequestTypesResponse = new GetRequestTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllOptionsFromJiraApiRequest$Type extends MessageType<GetAllOptionsFromJiraApiRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetAllOptionsFromJiraApiRequest", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAllOptionsFromJiraApiRequest>): GetAllOptionsFromJiraApiRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.installationId = "";
        if (value !== undefined)
            reflectionMergePartial<GetAllOptionsFromJiraApiRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllOptionsFromJiraApiRequest): GetAllOptionsFromJiraApiRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string installation_id */ 1:
                    message.installationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllOptionsFromJiraApiRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string installation_id = 1; */
        if (message.installationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.installationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetAllOptionsFromJiraApiRequest
 */
export const GetAllOptionsFromJiraApiRequest = new GetAllOptionsFromJiraApiRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllOptionsFromJiraApiResponse$Type extends MessageType<GetAllOptionsFromJiraApiResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.GetAllOptionsFromJiraApiResponse", [
            { no: 1, name: "installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "projects", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Project },
            { no: 3, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field },
            { no: 4, name: "text_fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field },
            { no: 5, name: "custom_app_fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field },
            { no: 6, name: "resolutions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResolutionState },
            { no: 7, name: "request_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServiceDeskRequestType }
        ]);
    }
    create(value?: PartialMessage<GetAllOptionsFromJiraApiResponse>): GetAllOptionsFromJiraApiResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.installationId = "";
        message.projects = [];
        message.fields = [];
        message.textFields = [];
        message.customAppFields = [];
        message.resolutions = [];
        message.requestTypes = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllOptionsFromJiraApiResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllOptionsFromJiraApiResponse): GetAllOptionsFromJiraApiResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string installation_id */ 1:
                    message.installationId = reader.string();
                    break;
                case /* repeated c1.api.external_ticketing.jira.v1.Project projects */ 2:
                    message.projects.push(Project.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.external_ticketing.jira.v1.Field fields */ 3:
                    message.fields.push(Field.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.external_ticketing.jira.v1.Field text_fields */ 4:
                    message.textFields.push(Field.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.external_ticketing.jira.v1.Field custom_app_fields */ 5:
                    message.customAppFields.push(Field.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.external_ticketing.jira.v1.ResolutionState resolutions */ 6:
                    message.resolutions.push(ResolutionState.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.external_ticketing.jira.v1.ServiceDeskRequestType request_types */ 7:
                    message.requestTypes.push(ServiceDeskRequestType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllOptionsFromJiraApiResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string installation_id = 1; */
        if (message.installationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.installationId);
        /* repeated c1.api.external_ticketing.jira.v1.Project projects = 2; */
        for (let i = 0; i < message.projects.length; i++)
            Project.internalBinaryWrite(message.projects[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.external_ticketing.jira.v1.Field fields = 3; */
        for (let i = 0; i < message.fields.length; i++)
            Field.internalBinaryWrite(message.fields[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.external_ticketing.jira.v1.Field text_fields = 4; */
        for (let i = 0; i < message.textFields.length; i++)
            Field.internalBinaryWrite(message.textFields[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.external_ticketing.jira.v1.Field custom_app_fields = 5; */
        for (let i = 0; i < message.customAppFields.length; i++)
            Field.internalBinaryWrite(message.customAppFields[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.external_ticketing.jira.v1.ResolutionState resolutions = 6; */
        for (let i = 0; i < message.resolutions.length; i++)
            ResolutionState.internalBinaryWrite(message.resolutions[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.external_ticketing.jira.v1.ServiceDeskRequestType request_types = 7; */
        for (let i = 0; i < message.requestTypes.length; i++)
            ServiceDeskRequestType.internalBinaryWrite(message.requestTypes[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.GetAllOptionsFromJiraApiResponse
 */
export const GetAllOptionsFromJiraApiResponse = new GetAllOptionsFromJiraApiResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BindJiraRequest$Type extends MessageType<BindJiraRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.BindJiraRequest", [
            { no: 1, name: "base_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { uri: true } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "integration_ref_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<BindJiraRequest>): BindJiraRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.baseUrl = "";
        message.displayName = "";
        message.integrationRefId = "";
        if (value !== undefined)
            reflectionMergePartial<BindJiraRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BindJiraRequest): BindJiraRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string base_url */ 1:
                    message.baseUrl = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string integration_ref_id */ 3:
                    message.integrationRefId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BindJiraRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string base_url = 1; */
        if (message.baseUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.baseUrl);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string integration_ref_id = 3; */
        if (message.integrationRefId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.integrationRefId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.BindJiraRequest
 */
export const BindJiraRequest = new BindJiraRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BindJiraResponse$Type extends MessageType<BindJiraResponse> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.BindJiraResponse", []);
    }
    create(value?: PartialMessage<BindJiraResponse>): BindJiraResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BindJiraResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BindJiraResponse): BindJiraResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BindJiraResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.BindJiraResponse
 */
export const BindJiraResponse = new BindJiraResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JiraConfig$Type extends MessageType<JiraConfig> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.JiraConfig", [
            { no: 1, name: "project_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_field_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "c1_label_filter", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "app_field_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "resource_field_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "requires_it_admin_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "status_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "cancelled_resolution_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "denied_resolution_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "granted_resolution_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "manual_provision_errored_resolution_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "request_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "comments_internal", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "auto_submit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<JiraConfig>): JiraConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.projectId = "";
        message.userFieldId = "";
        message.c1LabelFilter = false;
        message.appFieldId = "";
        message.resourceFieldId = "";
        message.requiresItAdminLabel = "";
        message.statusId = "";
        message.cancelledResolutionId = "";
        message.deniedResolutionId = "";
        message.grantedResolutionId = "";
        message.manualProvisionErroredResolutionId = "";
        message.requestTypeId = "";
        message.commentsInternal = false;
        message.autoSubmit = false;
        if (value !== undefined)
            reflectionMergePartial<JiraConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: JiraConfig): JiraConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string project_id */ 1:
                    message.projectId = reader.string();
                    break;
                case /* string user_field_id */ 2:
                    message.userFieldId = reader.string();
                    break;
                case /* bool c1_label_filter */ 3:
                    message.c1LabelFilter = reader.bool();
                    break;
                case /* string app_field_id */ 4:
                    message.appFieldId = reader.string();
                    break;
                case /* string resource_field_id */ 5:
                    message.resourceFieldId = reader.string();
                    break;
                case /* string requires_it_admin_label */ 6:
                    message.requiresItAdminLabel = reader.string();
                    break;
                case /* string status_id */ 7:
                    message.statusId = reader.string();
                    break;
                case /* string cancelled_resolution_id */ 8:
                    message.cancelledResolutionId = reader.string();
                    break;
                case /* string denied_resolution_id */ 9:
                    message.deniedResolutionId = reader.string();
                    break;
                case /* string granted_resolution_id */ 10:
                    message.grantedResolutionId = reader.string();
                    break;
                case /* string manual_provision_errored_resolution_id */ 11:
                    message.manualProvisionErroredResolutionId = reader.string();
                    break;
                case /* string request_type_id */ 12:
                    message.requestTypeId = reader.string();
                    break;
                case /* bool comments_internal */ 13:
                    message.commentsInternal = reader.bool();
                    break;
                case /* bool auto_submit */ 14:
                    message.autoSubmit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: JiraConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string project_id = 1; */
        if (message.projectId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.projectId);
        /* string user_field_id = 2; */
        if (message.userFieldId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userFieldId);
        /* bool c1_label_filter = 3; */
        if (message.c1LabelFilter !== false)
            writer.tag(3, WireType.Varint).bool(message.c1LabelFilter);
        /* string app_field_id = 4; */
        if (message.appFieldId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appFieldId);
        /* string resource_field_id = 5; */
        if (message.resourceFieldId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.resourceFieldId);
        /* string requires_it_admin_label = 6; */
        if (message.requiresItAdminLabel !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.requiresItAdminLabel);
        /* string status_id = 7; */
        if (message.statusId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.statusId);
        /* string cancelled_resolution_id = 8; */
        if (message.cancelledResolutionId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.cancelledResolutionId);
        /* string denied_resolution_id = 9; */
        if (message.deniedResolutionId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.deniedResolutionId);
        /* string granted_resolution_id = 10; */
        if (message.grantedResolutionId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.grantedResolutionId);
        /* string manual_provision_errored_resolution_id = 11; */
        if (message.manualProvisionErroredResolutionId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.manualProvisionErroredResolutionId);
        /* string request_type_id = 12; */
        if (message.requestTypeId !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.requestTypeId);
        /* bool comments_internal = 13; */
        if (message.commentsInternal !== false)
            writer.tag(13, WireType.Varint).bool(message.commentsInternal);
        /* bool auto_submit = 14; */
        if (message.autoSubmit !== false)
            writer.tag(14, WireType.Varint).bool(message.autoSubmit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.JiraConfig
 */
export const JiraConfig = new JiraConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Project$Type extends MessageType<Project> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.Project", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Project>): Project {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<Project>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Project): Project {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Project, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.Project
 */
export const Project = new Project$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Field$Type extends MessageType<Field> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.Field", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Field>): Field {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<Field>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Field): Field {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Field, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.Field
 */
export const Field = new Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolutionState$Type extends MessageType<ResolutionState> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.ResolutionState", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "is_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ResolutionState>): ResolutionState {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.name = "";
        message.description = "";
        message.isDefault = false;
        if (value !== undefined)
            reflectionMergePartial<ResolutionState>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResolutionState): ResolutionState {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* bool is_default */ 4:
                    message.isDefault = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResolutionState, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* bool is_default = 4; */
        if (message.isDefault !== false)
            writer.tag(4, WireType.Varint).bool(message.isDefault);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.ResolutionState
 */
export const ResolutionState = new ResolutionState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JiraStatus$Type extends MessageType<JiraStatus> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.JiraStatus", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status_category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "scope", kind: "message", T: () => Scope },
            { no: 6, name: "usages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Usage },
            { no: 7, name: "workflow_usages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WorkflowUsage }
        ]);
    }
    create(value?: PartialMessage<JiraStatus>): JiraStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.name = "";
        message.description = "";
        message.statusCategory = "";
        message.usages = [];
        message.workflowUsages = [];
        if (value !== undefined)
            reflectionMergePartial<JiraStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: JiraStatus): JiraStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string status_category */ 4:
                    message.statusCategory = reader.string();
                    break;
                case /* c1.api.external_ticketing.jira.v1.Scope scope */ 5:
                    message.scope = Scope.internalBinaryRead(reader, reader.uint32(), options, message.scope);
                    break;
                case /* repeated c1.api.external_ticketing.jira.v1.Usage usages */ 6:
                    message.usages.push(Usage.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.external_ticketing.jira.v1.WorkflowUsage workflow_usages */ 7:
                    message.workflowUsages.push(WorkflowUsage.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: JiraStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string status_category = 4; */
        if (message.statusCategory !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.statusCategory);
        /* c1.api.external_ticketing.jira.v1.Scope scope = 5; */
        if (message.scope)
            Scope.internalBinaryWrite(message.scope, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.external_ticketing.jira.v1.Usage usages = 6; */
        for (let i = 0; i < message.usages.length; i++)
            Usage.internalBinaryWrite(message.usages[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.external_ticketing.jira.v1.WorkflowUsage workflow_usages = 7; */
        for (let i = 0; i < message.workflowUsages.length; i++)
            WorkflowUsage.internalBinaryWrite(message.workflowUsages[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.JiraStatus
 */
export const JiraStatus = new JiraStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Scope$Type extends MessageType<Scope> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.Scope", [
            { no: 1, name: "project", kind: "message", T: () => ProjectId },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Scope>): Scope {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = "";
        if (value !== undefined)
            reflectionMergePartial<Scope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Scope): Scope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.external_ticketing.jira.v1.ProjectId project */ 1:
                    message.project = ProjectId.internalBinaryRead(reader, reader.uint32(), options, message.project);
                    break;
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Scope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.external_ticketing.jira.v1.ProjectId project = 1; */
        if (message.project)
            ProjectId.internalBinaryWrite(message.project, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.Scope
 */
export const Scope = new Scope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Usage$Type extends MessageType<Usage> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.Usage", [
            { no: 1, name: "issue_types", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "project", kind: "message", T: () => ProjectId }
        ]);
    }
    create(value?: PartialMessage<Usage>): Usage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.issueTypes = [];
        if (value !== undefined)
            reflectionMergePartial<Usage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Usage): Usage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string issue_types */ 1:
                    message.issueTypes.push(reader.string());
                    break;
                case /* c1.api.external_ticketing.jira.v1.ProjectId project */ 2:
                    message.project = ProjectId.internalBinaryRead(reader, reader.uint32(), options, message.project);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Usage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string issue_types = 1; */
        for (let i = 0; i < message.issueTypes.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.issueTypes[i]);
        /* c1.api.external_ticketing.jira.v1.ProjectId project = 2; */
        if (message.project)
            ProjectId.internalBinaryWrite(message.project, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.Usage
 */
export const Usage = new Usage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectId$Type extends MessageType<ProjectId> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.ProjectId", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ProjectId>): ProjectId {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ProjectId>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProjectId): ProjectId {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProjectId, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.ProjectId
 */
export const ProjectId = new ProjectId$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkflowUsage$Type extends MessageType<WorkflowUsage> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.WorkflowUsage", [
            { no: 1, name: "workflow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "workflow_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WorkflowUsage>): WorkflowUsage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.workflowId = "";
        message.workflowName = "";
        if (value !== undefined)
            reflectionMergePartial<WorkflowUsage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkflowUsage): WorkflowUsage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string workflow_id */ 1:
                    message.workflowId = reader.string();
                    break;
                case /* string workflow_name */ 2:
                    message.workflowName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkflowUsage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string workflow_id = 1; */
        if (message.workflowId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.workflowId);
        /* string workflow_name = 2; */
        if (message.workflowName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workflowName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.WorkflowUsage
 */
export const WorkflowUsage = new WorkflowUsage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServiceDeskRequestType$Type extends MessageType<ServiceDeskRequestType> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.ServiceDeskRequestType", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "help_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "issue_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "service_desk_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "portal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "group_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ServiceDeskRequestType>): ServiceDeskRequestType {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.name = "";
        message.description = "";
        message.helpText = "";
        message.issueTypeId = "";
        message.serviceDeskId = "";
        message.portalId = "";
        message.groupIds = [];
        if (value !== undefined)
            reflectionMergePartial<ServiceDeskRequestType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServiceDeskRequestType): ServiceDeskRequestType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string help_text */ 4:
                    message.helpText = reader.string();
                    break;
                case /* string issue_type_id */ 5:
                    message.issueTypeId = reader.string();
                    break;
                case /* string service_desk_id */ 6:
                    message.serviceDeskId = reader.string();
                    break;
                case /* string portal_id */ 7:
                    message.portalId = reader.string();
                    break;
                case /* repeated string group_ids */ 8:
                    message.groupIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServiceDeskRequestType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string help_text = 4; */
        if (message.helpText !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.helpText);
        /* string issue_type_id = 5; */
        if (message.issueTypeId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.issueTypeId);
        /* string service_desk_id = 6; */
        if (message.serviceDeskId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.serviceDeskId);
        /* string portal_id = 7; */
        if (message.portalId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.portalId);
        /* repeated string group_ids = 8; */
        for (let i = 0; i < message.groupIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.groupIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.ServiceDeskRequestType
 */
export const ServiceDeskRequestType = new ServiceDeskRequestType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServiceDeskIssueRequest$Type extends MessageType<ServiceDeskIssueRequest> {
    constructor() {
        super("c1.api.external_ticketing.jira.v1.ServiceDeskIssueRequest", [
            { no: 1, name: "issue_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "issue_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "request_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "service_desk_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ServiceDeskIssueRequest>): ServiceDeskIssueRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.issueId = "";
        message.issueKey = "";
        message.requestTypeId = "";
        message.serviceDeskId = "";
        if (value !== undefined)
            reflectionMergePartial<ServiceDeskIssueRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServiceDeskIssueRequest): ServiceDeskIssueRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string issue_id */ 1:
                    message.issueId = reader.string();
                    break;
                case /* string issue_key */ 2:
                    message.issueKey = reader.string();
                    break;
                case /* string request_type_id */ 3:
                    message.requestTypeId = reader.string();
                    break;
                case /* string service_desk_id */ 4:
                    message.serviceDeskId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServiceDeskIssueRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string issue_id = 1; */
        if (message.issueId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.issueId);
        /* string issue_key = 2; */
        if (message.issueKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.issueKey);
        /* string request_type_id = 3; */
        if (message.requestTypeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requestTypeId);
        /* string service_desk_id = 4; */
        if (message.serviceDeskId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.serviceDeskId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.jira.v1.ServiceDeskIssueRequest
 */
export const ServiceDeskIssueRequest = new ServiceDeskIssueRequest$Type();
/**
 * @generated ServiceType for protobuf service c1.api.external_ticketing.jira.v1.JiraService
 */
export const JiraService = new ServiceType("c1.api.external_ticketing.jira.v1.JiraService", [
    { name: "GetProjects", options: { "authz.method": { role: "VIEWER" } }, I: GetProjectsRequest, O: GetProjectsResponse },
    { name: "GetCustomAppFields", options: { "authz.method": { role: "VIEWER" } }, I: GetCustomAppFieldsRequest, O: GetCustomAppFieldsResponse },
    { name: "GetFields", options: { "authz.method": { role: "VIEWER" } }, I: GetFieldsRequest, O: GetFieldsResponse },
    { name: "GetTextFields", options: { "authz.method": { role: "VIEWER" } }, I: GetTextFieldsRequest, O: GetTextFieldsResponse },
    { name: "GetStatuses", options: { "authz.method": { role: "VIEWER" } }, I: GetStatusesRequest, O: GetStatusesResponse },
    { name: "GetResolutions", options: { "authz.method": { role: "VIEWER" } }, I: GetResolutionsRequest, O: GetResolutionsResponse },
    { name: "GetRequestTypes", options: { "authz.method": { role: "VIEWER" } }, I: GetRequestTypesRequest, O: GetRequestTypesResponse },
    { name: "GetAllOptionsFromJiraApi", options: { "authz.method": { role: "VIEWER" } }, I: GetAllOptionsFromJiraApiRequest, O: GetAllOptionsFromJiraApiResponse },
    { name: "BindJira", options: { "authz.method": { role: "EDITOR" } }, I: BindJiraRequest, O: BindJiraResponse }
]);
